import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { BsXLg } from "react-icons/bs";
import { FormGroup } from "reactstrap";
import userService from "../../../services/user.service";
import SuccessDialog from "../Popups/SuccessDialog";
import { POPUP_MESSAGE } from "../../../utils/constant";
import LoadingButton from "../../../Common/LoadingButton";

const HoursDetailsPopUP = ({ rowData, open }) => {
  const [detailsPopUp, setDetailsPoUP] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [addHours, setAddHours] = useState("");
  const [requested, setRequested] = useState(false);
  const [loading, setLoading] = useState(false);
  const sportId = rowData.sportId;

  useEffect(() => {
    if (successPopup) {
      document.body.style.overflow = "unset";
    }
  }, [successPopup]);

  const toggleSuccessDialog = () => {
    setSuccessPopup(!successPopup);
  };
  const handleHoursPopUp = (status) => {
    setDetailsPoUP(status);
  };
  const handleStateChange = (value) => {
    setAddHours(value);
  };

  const handleAddHours = () => {
    setLoading(true);
    userService.addHoursRequest(sportId, addHours).then((data) => {
      if (data.status === 200) {
        setRequested(true);
        setLoading(false);
        setSuccessPopup(true);
        setDetailsPoUP(false);
        toggleSuccessDialog();
      }
    });
  };
  return (
    <div
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {requested ||
      (rowData?.hoursPurchasedPending != null &&
        rowData?.hoursPurchasedPending != 0) ? (
        <button
          disabled={rowData?.hoursPurchasedPending || requested}
          className="btn buy-btn"
        >
          Already Requested
        </button>
      ) : (
        <button
          onClick={(event) => {
            event.stopPropagation();
            handleHoursPopUp(true);
          }}
          className="btn buy-btn"
        >
          Request More
        </button>
      )}
      <Modal className="hours-modal " show={detailsPopUp} backdrop="static">
        <Modal.Header className="text-left">
          <div className="d-flex justify-content-between w-100">
            <h6 className="fs-20 semi-bold black">Information</h6>
            <BsXLg
              onClick={(event) => {
                event.stopPropagation();
                handleHoursPopUp(false);
              }}
              className="crossview cp"
            ></BsXLg>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label>Sport Name</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.sportName}</p>
                </div>
              </div>
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label>Hours Purchased:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.totalHoursPurchased}</p>
                </div>
              </div>

              <div className="clear20"></div>

              <div className="clear10"></div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label>Hours Used:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.usedHours.toFixed(3)}</p>
                </div>
              </div>
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label> Hours Available:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.totalHoursAvailable.toFixed(3)}</p>
                </div>
              </div>
            </div>
            <div className="clear20"></div>

            <div className="col-md-6 col-lg-5">
              <div>
                <FormGroup>
                  <label className="fmlabel mt-6 semi-bold fs-18 black">
                    Add More Hours
                  </label>
                  <select
                    className="instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect"
                    name="specialty"
                    value={addHours}
                    onChange={(event) => {
                      event.stopPropagation();
                      handleStateChange(event.target.value);
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    <option value="">Select Hours</option>
                    <option>50</option>
                    <option>100</option>
                    <option>150</option>
                    <option>200</option>
                    <option>250</option>
                    <option>300</option>
                  </select>
                </FormGroup>
              </div>
            </div>
          </div>

          <div className="clear20"></div>
        </Modal.Body>
        <Modal.Footer>
          <div onClick={() => handleAddHours()}>
            <LoadingButton
              text={"Request"}
              loading={loading}
              disabled={loading || addHours == ""}
            />
          </div>
        </Modal.Footer>
      </Modal>
      <SuccessDialog
        successPopUp={successPopup}
        toggleSuccessDialog={toggleSuccessDialog}
        msg={POPUP_MESSAGE.hoursRequestSent}
      />
    </div>
  );
};

export default HoursDetailsPopUP;
